export default __webpack_public_path__ + "static/media/ic_uni_40.efe1f12f.svg";